import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import Links from "../../../Links";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";

const MuiProjectSection = styled(ProjectSection)`
  background: rgba(110, 46, 127, 1);
  background-color: rgba(110, 46, 127, 1);
  background-image: linear-gradient(hsla(242, 98%, 63%, 0.8) 0px, rgba(88, 0, 113, 0.6) 50%, rgba(0, 0, 0, 0.1) 90%),
    radial-gradient(at 80% 20%, hsla(28, 100%, 74%, 1) 20%, transparent 50%),
    radial-gradient(at 80% 0%, hsla(189, 100%, 56%, 1) 20%, transparent 50%),
    radial-gradient(at 0% 80%, hsla(355, 100%, 93%, 1) 20%, transparent 50%),
    radial-gradient(at 80% 50%, hsla(340, 100%, 76%, 1) 20%, transparent 50%),
    radial-gradient(at 0% 100%, hsla(22, 100%, 77%, 1) 20%, transparent 50%),
    radial-gradient(at 80% 100%, hsla(242, 100%, 70%, 1) 20%, transparent 50%),
    radial-gradient(at 0% 0%, hsla(343, 100%, 76%, 1) 20%, transparent 50%);
`;

const CodepenIframe = styled.iframe`
  width: 100%;
  display: block;
  height: 45.2rem;
  padding: 5.106382978723%;
  padding-bottom: 0px;
  min-height: 14.41667rem;
  background: #000000;
  border-top-left-radius: 1em;
  border-top-right-radius: 1em;
  margin-bottom: 0;
  border: none;
`;

const CodePenLink = styled(Links)`
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  &:hover,
  &:focus {
    color: white;
    border-bottom: none;
  }
  &:focus {
    outline-color: white;
  }
`;

function VirtualCard() {
  return (
    <MuiProjectSection>
      <ProjectTitle title="Virtual Card" tag="2021" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="HTML">
          <Icons type="html-small" />
        </Badge>
        <Badge small title="CSS">
          <Icons type="css-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription style={{ marginBottom: "var(--spacing-medium)" }}>
        At Airwallex, I prototyped a{" "}
        <CodePenLink href="https://codepen.io/trilm/pen/raBGaQQ" target="_blank" color="white">
          CodePen
        </CodePenLink>{" "}
        using mesh gradients and looping transitions to make virtual cards more dynamic than physical ones, creating an
        ever-shifting digital aesthetic.
      </ProjectDescription>

      <ProjectDescription>
        More recently, I built a web component called{" "}
        <CodePenLink href="https://muibook.com/#/smart-card" target="_blank" color="white">
          Smart Card
        </CodePenLink>{" "}
        found in the{" "}
        <CodePenLink href="https://muibook.com/#/smart-card" target="_blank" color="white">
          Muibook Design System
        </CodePenLink>{" "}
        that represents digital and physical cards for payments and reward experiences.
      </ProjectDescription>

      <CodepenIframe
        height="452"
        scrolling="no"
        title="Virtual Card"
        src="https://codepen.io/trilm/embed/raBGaQQ?default-tab=result&theme-id=dark"
        frameborder="no"
        allowtransparency="true"
        allowfullscreen="true"
      >
        See the Pen <a href="https://codepen.io/trilm/pen/raBGaQQ">Virtual Card</a> by Michael Trilford (
        <a href="https://codepen.io/trilm">@trilm</a>) on <a href="https://codepen.io">CodePen</a>.
      </CodepenIframe>
    </MuiProjectSection>
  );
}

export default VirtualCard;
